/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".chart-container[_ngcontent-%COMP%]{width:100%!important;display:block}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/core/achoo-column-chart-placeholder/achoo-column-chart-placeholder.component.scss.shim.ngstyle.js.pre-build-optimizer.js